/**
 * Named aliases over the GENERATED OpenAPI schema.
 *
 * `schema.d.ts` is produced from the backend's own contract
 * (`npm run gen:api`, see web/README.md) — nothing in this file re-declares a
 * shape by hand. If the backend changes, regenerate and the compiler points at
 * every place that has to move.
 */
import type { components } from './schema'

type S = components['schemas']

export type Health = S['Health']
export type DemoDossier = S['DemoDossier']
export type GemeindePack = S['GemeindePack']
export type StatusCount = S['StatusCount']
export type LayerCoverage = S['LayerCoverage']
export type SourceDoc = S['SourceDoc']

export type Run = S['Run']
export type Stage = S['Stage']
export type RunReport = S['RunReport']

export type Finding = S['Finding']
export type IndicativeFinding = S['IndicativeFinding']
export type Hinweis = S['Hinweis']
export type Nachweis = S['Nachweis']
export type SkippedRule = S['SkippedRule']
export type SourceRef = S['SourceRef']
export type ComputedValues = S['ComputedValues']
export type Ampel = S['Ampel']

// M2 — tenancy, auth and audit. Same rule: generated, never hand-written.
export type SessionInfo = S['SessionInfo']
export type WorkspaceRef = S['WorkspaceRef']
export type MemberRef = S['MemberRef']
export type InviteRef = S['InviteRef']
export type InviteCreated = S['InviteCreated']
export type DossierRef = S['DossierRef']
export type AuditEventRef = S['AuditEventRef']
export type Accepted = S['Accepted']

// M2 — dossier intake. Generated like everything else.
export type DossierUploaded = S['DossierUploaded']
export type DossierFileRef = S['DossierFileRef']
export type Notice = S['Notice']

// M2 — the facts review surface (the trust surface) and the correction loop.
export type FactsView = S['FactsView']
export type FactField = S['FactField']
export type FactEdit = S['FactEdit']
export type MissingInput = S['MissingInput']
export type RecheckResult = S['RecheckResult']
export type RunDiff = S['RunDiff']
export type FindingChange = S['FindingChange']
export type FactChange = S['FactChange']
export type RunCost = S['RunCost']

// M5 — retention and the founder dashboard. Generated like the rest.
export type DossierDeleted = S['DossierDeleted']
export type WorkspaceDeleted = S['WorkspaceDeleted']
export type RetentionOverview = S['RetentionOverview']
export type RetentionWorkspace = S['RetentionWorkspace']
export type RetentionSweepResult = S['RetentionSweepResult']
export type AdminOverview = S['AdminOverview']
export type AdminWorkspaceRow = S['AdminWorkspaceRow']
export type AdminTotals = S['AdminTotals']
export type AdminRunRow = S['AdminRunRow']
export type VerificationQueueItem = S['VerificationQueueItem']

// 2026-09-17 — the rule-level detail of a COMMITTED pack (Founder decision).
// Read-only and global: `GET /api/v1/gemeinden/{kanton}/{gemeinde}`. Generated
// like the rest; the counts in `GemeindePack` are the counts of these rows.
export type CommittedPackDetail = S['CommittedPackDetail']
export type CommittedZoneRow = S['CommittedZoneRow']
export type CommittedRule = S['CommittedRule']
export type CommittedLayerRules = S['CommittedLayerRules']

/** deterministisch | llm | gis | manuell | unbekannt — as the backend declares it. */
export type Provenance = FactField['provenance']
/** The value a fact can hold. Same union on both sides of the seam. */
export type FactValue = FactField['value']
export type FactGroup = FactField['group']
export type NoticeCode = Notice['code']
export type NoticeKind = Notice['kind']
export type RunMode = Run['mode']
export type ChangeKind = FindingChange['change']

/**
 * The multipart form the intake endpoint accepts, as FastAPI declares it.
 *
 * `client.ts` names its form fields through `keyof DossierUploadBody`, so a
 * renamed or dropped field on the server is a compile error here instead of a
 * silently ignored part in a request that then fails with 422 at a prospect's
 * desk.
 */
export type DossierUploadBody =
  S['Body_upload_dossier_api_v1_workspaces__workspace_id__dossiers_post']

/**
 * The multipart form the BZO ingestion accepts, as FastAPI declares it — same
 * discipline as the dossier intake: `client.ts` names every field through
 * `keyof BzoIngestBody`, so a renamed field on the server is a compile error
 * here rather than a 422 at a founder's desk.
 */
export type BzoIngestBody =
  S['Body_create_ingestion_api_v1_workspaces__workspace_id__rulebase_ingestions_post']

export type Severity = Finding['severity']
export type RunState = Run['status']
export type StageState = Stage['status']
export type GlobalRole = SessionInfo['global_role']

// ---------------------------------------------------------------------------
// M4 — the rulebase manager: BZO ingestion and the verification gate.
//
// These shapes are the CONTRACT agreed with the backend for M4. They are not
// hand-maintained duplicates of something the backend already declares: the
// `Generated<>` alias below prefers the generated schema the moment the backend
// publishes a component of that name, so `npm run gen:api` is what retires the
// provisional shape — and any drift between the two becomes a compile error at
// the call sites instead of a 422 at a founder's desk.
//
// Anything still provisional when this ships is listed in the handoff. Nothing
// here is a mock: the call sites in client.ts hit the real paths, and a missing
// endpoint surfaces as the server's own error, not as fabricated data.
// ---------------------------------------------------------------------------

/** The generated type for `K` if the backend declares it, else the contract shape. */
type Generated<K extends string, Provisional> = K extends keyof S ? S[K & keyof S] : Provisional

/**
 * Where an extracted value came from in the source document, precise enough
 * that a human can go and look: which document, which page, and the text that
 * was read. A verification is only ever recorded together with one of these —
 * see `client.ts`, which has no way to send a confirmation without it.
 *
 * One model for input and output. On input `snippet` is required (min 4 chars)
 * and the server answers 422 without it; `source_url` is output-only and is
 * null for the repo packs, whose PDFs are not served — for those the snippet
 * and the page reference are the citation, and the UI says so rather than
 * offering a link that would 404.
 */
export interface CitationShape {
  document_key: string | null
  document_title: string | null
  page: number | null
  snippet: string
  /** Output only: the source route including the `#page=` fragment. */
  source_url?: string | null
}
export type Citation = Generated<'Citation', CitationShape>

/** verified | unverified | placeholder — the rulebase's own status convention. */
export type ItemStatus = 'verified' | 'unverified' | 'placeholder'

export interface DraftParameterShape {
  key: string
  label_de: string
  /** `null` means "not read" — never a zero, never a plausible default. */
  value: string | number | boolean | null
  unit?: string | null
  status: ItemStatus
  citation?: CitationShape | null
}
export type DraftParameter = Generated<'DraftParameter', DraftParameterShape>

export interface DraftZoneShape {
  id: string
  code: string
  label?: string | null
  status: ItemStatus
  citation?: CitationShape | null
  parameters?: DraftParameterShape[]
}
export type DraftZone = Generated<'DraftZone', DraftZoneShape>

/** The comparison a computable rule performs. A literal operand, never a string. */
export type CheckOp = '<=' | '>=' | '==' | '<' | '>'
export interface RuleCheckShape {
  op: CheckOp
  value: number | boolean
}
export type RuleCheck = Generated<'DraftCheck', RuleCheckShape>

/** What the extraction found that a verified repo pack contradicts. */
export interface PackConflictShape {
  kind: 'zone_parameter' | 'zone_missing' | 'regime' | 'abstand_regime'
  zone?: string | null
  key?: string | null
  message_de: string
}
export type PackConflict = Generated<'PackConflict', PackConflictShape>

export interface DraftRuleShape {
  id: string
  title_de: string
  kind?: 'computable' | 'required' | 'nachweis' | 'narrative' | null
  status: ItemStatus
  citation?: CitationShape | null
  /**
   * ABSENT on a freshly ingested rule — the backend does not emit the field at
   * all, not even as null. An auto-generated draft pack is data only; the
   * comparison enters the rule when a human reads the cited source and types
   * the operator and the operand in. `value` is a literal, and there is no
   * expression string anywhere in this API: a pack carrying a `value_expr` key
   * is rejected at ingestion and again at load, before a run can touch it.
   */
  check?: RuleCheckShape | null
  artifact?: string | null
}
export type DraftRule = Generated<'DraftRule', DraftRuleShape>

/**
 * A zone row and its parameters verify separately — the row is what flips the
 * Gemeinde out of indicative mode, the parameters are what a check computes
 * with — so the coverage carries both counters and the UI shows both.
 */
export interface DraftCoverageShape {
  zones: StatusCount
  zone_parameters: StatusCount
  rules: StatusCount
}
export type DraftCoverage = Generated<'DraftCoverage', DraftCoverageShape>

export interface DraftPackShape {
  pack_id: string
  gemeinde: string
  kanton: string
  draft: boolean
  mode: 'verified' | 'indicative'
  zones?: DraftZoneShape[]
  rules?: DraftRuleShape[]
  sources?: SourceDoc[]
  coverage: DraftCoverageShape
  /**
   * True when a verified pack for this Gemeinde already exists in the repo.
   * The draft then stays readable but is never used for a run — a state that
   * is baffling unless it is said out loud, so the UI says it out loud.
   */
  shadowed: boolean
  conflicts?: PackConflictShape[]
  status_note_de?: string | null
}
export type DraftPack = Generated<'DraftPack', DraftPackShape>

/** A draft pack as it appears in the workspace's list — the row, not the body. */
export interface DraftPackRefShape {
  pack_id: string
  gemeinde: string
  kanton: string
  slug: string
  shadowed: boolean
}
export type DraftPackRef = Generated<'DraftPackRef', DraftPackRefShape>

export interface RulebaseIngestionShape {
  id: string
  status: 'queued' | 'running' | 'succeeded' | 'failed'
  gemeinde: string
  kanton: string
  pack_id?: string | null
  /** Keys: dokument_pruefen · text_lesen · zonen_lesen · entwurf_pruefen · entwurf_ablegen */
  stages?: Stage[]
  notices?: Notice[]
  error?: string | null
}
export type RulebaseIngestion = Generated<'RulebaseIngestion', RulebaseIngestionShape>

/** What a human decided about one extracted item, against the cited source. */
export type Disposition = 'confirmed' | 'corrected' | 'unreadable'

/**
 * The item key that stands for the zone ROW itself rather than one of its
 * parameters. Confirming it is what takes the row — and with it the Gemeinde —
 * out of indicative mode, so it is a deliberate act with its own citation, not
 * a side effect of confirming the last parameter.
 */
export const ZONE_ROW_KEY = '__zone__'

/**
 * Third compile-time guard, for the M4 gate: no rule in this API may carry a
 * string expression. `value_expr` was the shape a formula would have travelled
 * in; the backend rejects a pack containing that key, and this line makes the
 * frontend unable to grow one back if the schema is ever regenerated with it.
 */
export type RuleCheckCarriesNoExpression = 'value_expr' extends keyof RuleCheck ? never : true
export const RULE_CHECK_CARRIES_NO_EXPRESSION: RuleCheckCarriesNoExpression = true

/**
 * Compile-time guard for the structural invariant that matters most in the UI:
 * an indicative finding must never carry a traffic-light severity. If the
 * backend ever grew one, this line stops the build instead of letting the
 * frontend quietly paint an unverified rule red.
 */
export type IndicativeHasNoSeverity = 'severity' extends keyof IndicativeFinding ? never : true
export const INDICATIVE_HAS_NO_SEVERITY: IndicativeHasNoSeverity = true

/**
 * Second compile-time guard, for the facts surface: a re-check may never call a
 * model. The backend states that as `llm_called: Literal[False]`; if it ever
 * widened to a plain boolean, the loop would silently stop being the "no LLM
 * re-call" the brief promises — and this line would stop the build first.
 */
export type RecheckNeverCallsAModel = RecheckResult['llm_called'] extends false ? true : never
export const RECHECK_NEVER_CALLS_A_MODEL: RecheckNeverCallsAModel = true
